import { render, staticRenderFns } from "./AppRankingAcademia.vue?vue&type=template&id=4bb51ac6&"
import script from "./AppRankingAcademia.vue?vue&type=script&lang=js&"
export * from "./AppRankingAcademia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports